import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { lifecycle, compose, withHandlers } from "recompose";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import { forEach } from "lodash";

import SelectField from "../../components/form/SelectField";
import TextField from "../form/TextField";
import Checkbox from "../form/Checkbox";
import * as Validation from "../form/Validation";

import { setActiveForm } from "../../actions/appActions";
import {updateHost, getHost, getHostCategories} from "../../actions/resourceActions";

let getHostCategories_toMenuItems = ( state ) =>
{

    let { resource: { hostCategories }} = state;
    let menuItems = [];

    forEach( hostCategories, (hostCategory) =>
    {
        menuItems.push({label: hostCategory.name, value: hostCategory.id });
    });

    return menuItems;
};


const Info = ( reactState ) => {

    let { host, activeForm, handleSubmit, setActiveForm, change, state } = reactState;


    let categories_asMenuItems = getHostCategories_toMenuItems( state );

  return (
    <Card raise className="margin-bottom-small">
      {activeForm === "hostUpdateForm" ? (
        <CardText>
          <form onSubmit={handleSubmit}>
            <Field
              component={TextField}
              label="Název"
              name="name"
              validate={[Validation.required]}
            />
            <Field
              component={TextField}
              label="Adresa"
              name="address"
              validate={[Validation.required]}
            />
            <Field
              component={TextField}
              label="Poznámky"
              name="notes"
              rows={5}
            />
              <Field
                  component={SelectField}
                  label="Kategorie"
                  name="category.id"
                  menuItems={categories_asMenuItems}
              />
            <Field
              component={Checkbox}
              name="dedicated"
              text="Vyhrazen"
              changeValue={change}
            />
            <div className="flex-row flex-right">
              <Button
                flat
                label="Zrušit"
                className="btn"
                onClick={() => setActiveForm(null)}
              />
              <Button
                flat
                primary
                label="Odeslat"
                type="submit"
                className="btn btn-primary"
              />
            </div>
          </form>
        </CardText>
      ) : (
        <CardText >
          <div className="flex-row">
            <p className="info-label">Adresa:</p>
            <p>{host.address}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Poznámky:</p>
            <p>{host.notes}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Vyhrazen:</p>
            <p>{host.dedicated ? "Ano" : "Ne"}</p>
          </div>
            <Button flat
                    primary
                    label="Upravit"
                    className="btn btn-primary"
                    onClick={() => setActiveForm("hostUpdateForm")}
            />
        </CardText>
      )}
    </Card>
  );
};

export default compose(
  connect((state) => {
      let { app: { form: { activeForm } } } = state;
      return ({
          activeForm,
          state
      });
    }, {
    setActiveForm,
    updateHost,
    getHost,
    getHostCategories
  }),
  lifecycle({
      async componentWillMount()
      {
        let { getHostCategories } = this.props;

        getHostCategories();
      }
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { setActiveForm, updateHost, host, getHost } = props;

      if (await updateHost({ ...host, ...formData })) {
        await getHost(host.id);
        setActiveForm(null);
      } else
        throw new SubmissionError({
          dedicated: "Update hosta se nepodařil."
        });
    }
  }),
  reduxForm({ form: "hostUpdateForm" })
)(Info);



// WEBPACK FOOTER //
// ./src/components/host/Info.js